import React from "react";
import styled from "styled-components";
import cn from "classnames";

export const RATypography = ({
	children = "",
	variant,
	align,
	style,
	color,
	top,
	left,
	right,
	bottom,
	gutterBottom,
	decoration,
	onClick,
	whiteSpace,
	classname,
	maxLines,
	truncate = false,
}) => {
	let textStyle = { ...style };

	if (color) textStyle.color = color;
	if (top) textStyle.marginTop = top;
	if (left) textStyle.marginLeft = left;
	if (right) textStyle.marginRight = right;
	if (bottom) textStyle.marginBottom = bottom;
	if (whiteSpace) textStyle.whiteSpace = whiteSpace;
	if (truncate)
		textStyle = {
			...textStyle,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		};

	return (
		<Text
			className={cn({ [`typo--${variant}`]: variant }, classname)}
			style={textStyle}
			align={align}
			gutterBottom={gutterBottom}
			decoration={decoration}
			onClick={onClick}
			maxLines={maxLines}
		>
			{children}
		</Text>
	);
};

const Text = styled.p`
	text-align: ${({ align }) => align};
	margin-bottom: ${({ gutterBottom }) => gutterBottom};
	text-decoration: ${({ decoration }) => decoration};
	padding: 0;
	margin: 0;

	${({ maxLines }) =>
		maxLines > 0 &&
		`
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${maxLines};
        overflow: hidden;
    `}

	&.typo--h1 {
		color: #222222;
		font-family: "Gilda Display";
		font-weight: 400;
		font-size: 56px;
		line-height: 80px;
		letter-spacing: 0.5px;
	}
	&.typo--h2 {
		color: #222222;
		font-family: "Gilda Display";
		font-weight: 400;
		font-size: 36px;
		line-height: 50px;
	}
	&.typo--h3 {
		color: #222222;
		font-family: "Gilda Display";
		font-weight: 400;
		font-size: 28px;
		line-height: 38px;
	}
	&.typo--h4 {
		color: #222222;
		font-family: "Gilda Display";
		font-weight: 400;
		font-size: 24px;
		line-height: 34px;
	}
	&.typo--h5 {
		color: #222222;
		font-family: "Gilda Display";
		font-weight: 400;
		font-size: 18px;
		line-height: 28px;
	}
	&.typo--h6 {
		color: #fff;
		font-family: "Gilda Display";
		font-weight: 400;
		font-size: 24px;
		line-height: 34px;
		text-transform: capitalize;
	}
	&.typo--title {
		text-align: center;
		font-family: "Gilda Display";
		font-size: 56px;
		font-weight: 400;
		line-height: 80px;
		letter-spacing: 0.5px;
		background: linear-gradient(180deg, #ffffff 39.72%, rgba(255, 255, 255, 0) 140.65%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;

		@media (max-width: 767px) {
			font-size: 36px;
			line-height: 50px;
		}

		@media (max-width: 575px) {
			font-size: 28px;
			line-height: 38px;
		}
	}
	&.typo--sub_title {
		color: #222222;
		font-weight: 400;
		font-size: 20px;
		line-height: 28px;

		@media (max-width: 767px) {
			font-size: 16px;
			line-height: 24px;
		}
	}
	&.typo--p {
		color: #65686f;
		font-weight: 400;
		font-size: 14px;
		line-height: 24px;
	}
	&.typo--sub-heading1 {
		color: #222222;
		font-weight: 500;
		font-size: 24px;
		line-height: 32px;
	}
	&.typo--sub-heading2 {
		color: #222222;
		font-weight: 500;
		font-size: 20px;
		line-height: 28px;
	}
	&.typo--sub-heading3 {
		color: #222222;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
	}
	&.typo--sub-heading4 {
		color: #222222;
		font-weight: 500;
		font-size: 14px;
		line-height: 22px;
	}
	&.typo--sub-heading5 {
		color: #222222;
		font-weight: 400;
		font-size: 12px;
		line-height: 20px;
	}
	&.typo--button1 {
		color: #222222;
		font-weight: 500;
		font-size: 14px;
		line-height: 30px;
		letter-spacing: 3px;
		text-transform: uppercase;
		text-indent: 3px;
	}
	&.typo--button2 {
		color: #222222;
		font-weight: 500;
		font-size: 12px;
		line-height: 26px;
		letter-spacing: 1px;
		text-transform: uppercase;
		text-indent: 1px;
	}
	&.typo--button3 {
		color: #222222;
		font-weight: 500;
		font-size: 10px;
		line-height: 20px;
		letter-spacing: 1px;
		text-transform: uppercase;
		text-indent: 1px;
	}
	&.typo--body1 {
		color: #222222;
		font-weight: 400;
		font-size: 20px;
		line-height: 28px;
	}
	&.typo--body2 {
		color: #222222;
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
	}
	&.typo--body3 {
		color: #222222;
		font-weight: 400;
		font-size: 14px;
		line-height: 22px;
	}
	&.typo--body4 {
		color: #222222;
		font-weight: 400;
		font-size: 12px;
		line-height: 20px;
	}
	&.typo--body5 {
		color: #222222;
		font-weight: 500;
		font-size: 20px;
		line-height: 28px;
	}
	&.typo--label1 {
		color: #222222;
		font-weight: 700;
		font-size: 16px;
		line-height: 22px;
		letter-spacing: 1px;
		text-transform: uppercase;
	}
	&.typo--label2 {
		color: #222222;
		font-weight: 700;
		font-size: 14px;
		line-height: 22px;
		letter-spacing: 1px;
		text-transform: uppercase;
	}
	&.typo--label3 {
		color: #222222;
		font-weight: 700;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 1px;
		text-transform: uppercase;
	}
	&.typo--label4 {
		color: #222222;
		font-weight: 700;
		font-size: 10px;
		line-height: 18px;
		letter-spacing: 1px;
		text-transform: uppercase;
	}
	&.typo--gilda1 {
		color: #222222;
		font-family: "Gilda Display";
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		text-transform: capitalize;
	}
	&.typo--gilda2 {
		color: #222222;
		font-family: "Gilda Display";
		font-size: 18px;
		font-weight: 400;
		line-height: 26px;
		text-transform: capitalize;
		padding-left: 12px;
		position: relative;

		&::before {
			content: "";
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			width: 2px;
			height: 26px;
			background-color: #ffb11a;
		}
	}
	&.typo--gilda3 {
		color: #222222;
		font-family: "Gilda Display";
		font-size: 36px;
		font-weight: 400;
		line-height: 50px;
		text-transform: capitalize;
		padding-left: 12px;
		position: relative;

		&::before {
			content: "";
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			width: 2px;
			height: 50px;
			background-color: #ffb11a;
		}
	}
	&.typo--dm_sans1 {
		color: #222222;
		font-weight: 400;
		font-size: 12px;
		line-height: 20px;
	}
`;
